import { GET_OUR_WORK_START } from '../../types';

export const get_our_work = (payload) => ({
  type: GET_OUR_WORK_START,
  payload,
});
